import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'हमारी पसंद',
  bestPriceBadge: 'सबसे कम कीमत',
  regulatedNotice: {
    prescriptionOnly: 'सिर्फ़ प्रिस्क्रिप्शन पर',
    professionalUse: 'पेशेवर इस्तेमाल के लिए',
    fromVeterinarian: 'आपके पशु-चिकित्सक के पास उपलब्ध',
    fromPharmacist: 'फ़ार्मासिस्ट के पास उपलब्ध',
    noOnlinePurchase: 'ऑनलाइन नहीं बिकता',
    professionalSupply: 'पेशेवर सप्लायर के ज़रिए बिकता है',
    whyNoLink: 'हम इस उत्पाद की समीक्षा करते हैं, पर इसका लिंक नहीं देते।',
  },
};
